import {FC, ReactNode, useEffect, useState} from 'react'
import styles from './BaseModal.module.css'

type Props = {
  onCloseAction: () => void
  title: string
  children: ReactNode
  width?: string
}

const BaseModal: FC<Props> = ({onCloseAction, title, children, width = '30rem'}) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      onCloseAction()
    }, 300) // Tempo da animação
  }

  return (
    <>
      <div
        onClick={handleClose}
        className={`${styles.background} ${isClosing ? styles.fadeOut : ''}`}
      ></div>
      <div className={`${styles.modalCustom} ${isClosing ? styles.slideOut : ''}`} style={{width}}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3 className={styles.modalTitle}>{title}</h3>
            <button type='button' className={styles.closeButton} onClick={handleClose}>
              <i className={`fas fa-times ${styles.closeButtonIcon}`}></i>
            </button>
          </div>
          <div className={styles.modalBody}>{children}</div>
        </div>
      </div>
    </>
  )
}

export {BaseModal}
